import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ParameterLine } from "../../ui/ParameterLine";
import type { PublicationInfo } from "./useTaskDetailSubscription";
import type { JSX } from "react";

export function PublicationParamsSection(props: { publication: PublicationInfo }) {
  let publicationParametersSection: JSX.Element;
  const { publication } = props;
  if (publication.publishedParam === null) {
    const uniqueSiteCount = new Set(publication.items.map((item) => item.siteUrl)).size;
    publicationParametersSection = (
      <Box
        mb={3}
        p={2}
        sx={{ bgcolor: "action.hover", borderRadius: 1, border: 1, borderColor: "divider" }}
      >
        <Typography variant="h6" mb={1}>
          Параметры публикации
        </Typography>
        <ParameterLine name="Режим" value="Override (список сайтов задан вручную)" />
        <ParameterLine name="Количество сайтов" value={String(uniqueSiteCount)} />
        <ParameterLine name="Автозапуск" value={publication.autoStarted ? "Да" : "Нет"} />
      </Box>
    );
  } else {
    const regionsText = publication.publishedGeos.length > 0
      ? publication.publishedGeos.join(", ")
      : "—";
    publicationParametersSection = (
    <Box
      mb={3}
      p={2}
      sx={{ bgcolor: "action.hover", borderRadius: 1, border: 1, borderColor: "divider" }}
    >
      <Typography variant="h6" mb={1}>
        Параметры публикации
      </Typography>
      <ParameterLine name="Регионы" value={regionsText} />
      <ParameterLine name="DR ≥" value={String(publication.publishedParam.dr)} />
      <ParameterLine name="Organic Keywords ≥" value={String(publication.publishedParam.organicKeywords)} />
      <ParameterLine name="Возраст домена ≥ (лет)" value={String(publication.publishedParam.age)} />
      <ParameterLine name="Уникальные сайты" value={publication.publishedParam.uniqueSites ? "Да" : "Нет"} />
      <ParameterLine name="Включать субдомены" value={publication.publishedParam.includeSubdomains ? "Да" : "Нет"} />
      <ParameterLine name="Автозапуск" value={publication.autoStarted ? "Да" : "Нет"} />
    </Box>
  );
  }
  return publicationParametersSection;
}
